import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lines-shimmer',
  templateUrl: './lines-shimmer.component.html',
  styleUrls: ['./lines-shimmer.component.scss']
})
export class LinesShimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
